import { styled, css, Badge } from '@mui/material';
import { NavLink, Link } from 'react-router-dom';
import { theme } from 'assets/themes/zizzi';

const menuItemColor = theme.palette.white;
const menuItemActiveColor = theme.palette.primary.light;
const menuItemHoverColor = theme.palette.primary.dark;
const menuItemHoverBorderColor = theme.palette.neutral.dark;
const primaryBadgeTextColour = theme.palette.primary.main;
const primaryBadgeBgColour = theme.palette.white;

const borderStyles = css`
  background: ${menuItemColor};
  border-radius: 2px;
  bottom: 7px;
  content: '';
  display: block;
  height: 2px;
  left: 50%;
  margin: auto;
  position: absolute;
  transform: translateX(-50%);
  transition: all 0.3s ease-in;
  width: 85%;
`;

const menuItemStyles = css`
  border-radius: ${theme.radius?.md};
  color: ${menuItemColor};
  font-size: 16px;
  font-weight: 700;
  margin: 10px;
  padding: 0.75rem;
  padding-top: 0.25rem;
  position: relative;
  text-decoration: none;
  transition: background-color 0.3s ease-in;

  svg {
    fill: ${menuItemColor};
    font-size: 20px;
    margin-right: 5px;
    margin-bottom: -4px;
    height: 18px;
    width: 18px;
  }

  &.active {
    background-color: ${menuItemActiveColor};
  }

  &:before {
    ${borderStyles}
  }

  &:after {
    ${borderStyles}
    background-color: ${menuItemHoverBorderColor};
    width: 0;
  }

  &:hover {
    background-color: ${menuItemHoverColor};

    &:after {
      width: 85%;
    }
  }
`;

export const MenuItem = styled(NavLink)`
  ${menuItemStyles}
`;

export const MenuItemWithClick = styled(Link)`
  ${menuItemStyles}
`;

export const StyledBadge = styled(Badge)`
  .MuiBadge-badge {
    right: 11px;
    top: 12px;

    &.MuiBadge-colorPrimary {
      background: ${primaryBadgeBgColour};
      color: ${primaryBadgeTextColour};
    }
  }
`;
